import { create } from 'zustand'

type UiState = {
  sidebarOpen: boolean
  activeLayers: string[]
  selectedEventId?: string
  selectedDeviceId?: string
  mapFocus?: { lat: number; lon: number; zoom?: number }
  realtimeState: 'connected' | 'connecting' | 'degraded' | 'offline'
  setSidebarOpen(open: boolean): void
  toggleLayer(layer: string): void
  selectEvent(id?: string): void
  selectDevice(id?: string): void
  focusMap(lat: number, lon: number, zoom?: number): void
  setRealtimeState(state: UiState['realtimeState']): void
}

export const useUiStore = create<UiState>((set) => ({
  sidebarOpen: false,
  activeLayers: ['devices', 'epicenters', 'intensity', 'live', 'waves', 'tracks'],
  realtimeState: 'offline',
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
  toggleLayer: (layer) =>
    set((state) => ({
      activeLayers: state.activeLayers.includes(layer)
        ? state.activeLayers.filter((item) => item !== layer)
        : [...state.activeLayers, layer],
    })),
  selectEvent: (selectedEventId) => set({ selectedEventId }),
  selectDevice: (selectedDeviceId) => set({ selectedDeviceId }),
  focusMap: (lat, lon, zoom) => set({ mapFocus: { lat, lon, zoom } }),
  setRealtimeState: (realtimeState) => set({ realtimeState }),
}))
